// Provider names are presentation; Floorball season/competition IDs and
// Hockey simulation keys identify the actual league.
const floorballIdentity = (url) => {
  const parts = /\/sasong\/(\d+)\/serie\/(\d+)(?:\/|$)/.exec(url || '');
  return parts ? `floorball:${parts[1]}:${parts[2]}` : null;
};

export function buildLeagueFilters(matches, allLeagues) {
  const groups = new Map();
  const aliases = new Map();
  const add = (identity, name, daily) => {
    if (!name) return;
    const key = identity || `name:${name}`;
    const group = groups.get(key) || { name, daily: false };
    // Retain the daily provider label to match the visible match cards.
    if (daily && !group.daily) group.name = name;
    group.daily ||= daily;
    groups.set(key, group);
    if (!aliases.has(name)) aliases.set(name, new Set());
    aliases.get(name).add(key);
  };
  allLeagues.forEach((league) => add(floorballIdentity(league.source_url) || (league.key ? `simulation:${league.key}` : null), league.name, false));
  matches.forEach((match) => {
    const identity = floorballIdentity(match.match_link) || (match.simulation ? `simulation:${match.simulation}` : null);
    // Exact names remain a safe fallback for providers without identity data.
    const known = aliases.get(match.league);
    add(identity || (known?.size === 1 ? [...known][0] : null), match.league, true);
  });
  const options = [...groups.entries()].map(([key, group]) => ({ key, ...group }))
    .sort((a, b) => Number(b.daily) - Number(a.daily) || a.name.localeCompare(b.name, 'sv'));
  const selected = (option, names) => names.some((name) => aliases.get(name)?.has(option.key));
  const matchesSelection = (match, names) => {
    if (!names.length) return true;
    const identity = floorballIdentity(match.match_link) || (match.simulation ? `simulation:${match.simulation}` : null);
    return names.some((name) => identity ? aliases.get(name)?.has(identity) : name === match.league);
  };
  return { options, selected, matchesSelection, aliases };
}
